import { NavLink as NL, NavLinkProps } from 'react-router-dom';
import {
  ReactNode,
} from 'react';
import { asMenuItem } from './MenuItem.utils';

type MenuItemProps = NavLinkProps & {
  icon?: ReactNode;
  children: ReactNode;
}

const NavLink = asMenuItem(NL);

export default function MenuItem({ icon, children, ...rest }: MenuItemProps) {
  return (
    <NavLink
      {...rest}
    >
      {icon ? <div className="size-5 flex items-center justify-center">{icon}</div> : null}
      {children}
    </NavLink>
  );
}
